<div class="search-input">
  <mat-form-field appearance="outline" class="q9-form-field q9-full-width" [floatLabel]="'always'">
    <mat-label>{{ 'RUBIC_CUBE.SEARCH_PARENT' | translate }}</mat-label>
    <button
      mat-icon-button
      matPrefix
      class="q9-clear-btn"
      [disableRipple]="true"
      *ngIf="searchFormControl.value && !(loading$ | async)"
      (click)="clearSearchInput()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <mat-icon
      matPrefix
      svgIcon="search"
      class="toolbar-search-input-icon"
      *ngIf="!searchFormControl.value && !(loading$ | async)"></mat-icon>
    <mat-spinner
      matPrefix
      strokeWidth="1"
      diameter="20"
      class="search-field-spinner"
      *ngIf="loading$ | async"></mat-spinner>
    <input
      matInput
      class="toolbar-search-input"
      [matTooltip]="'CORE.ATTACHMENTS.NODE_SEARCH_TOOLTIP' | translate"
      matTooltipShowDelay="200"
      matTooltipHideDelay="200"
      [formControl]="searchFormControl"
      (keydown.esc)="clearSearchInput()"
      [readonly]="disableSearch"
      autocomplete="off"
      [errorStateMatcher]="matcher" />
  </mat-form-field>
  <div class="nodes-list" *ngIf="nodeList?.length">
    <div
      class="nodes-list-item"
      *ngFor="let node of nodeList"
      matTooltipShowDelay="400"
      matTooltipHideDelay="400"
      [matTooltip]="node.sf.fullPath"
      (click)="addParent(node)">
      {{ node.name }}
      <div class="nodes-list-item-subtitle">{{ node.sf.fullPath }}</div>
    </div>
  </div>
</div>
